export class HeaderSearchInit {
  constructor() {
    this.openHeaderSearch()
  }

  openHeaderSearch() {
    const searchBtns = document.querySelectorAll(".search_btn")
    const searchInput = document.getElementById("search-wrap")
    const backdrop = document.querySelector(".search_backdrop")

    if (!searchBtns.length || !searchInput || !backdrop) return

    const toggleSearch = (btn) => {
      const isOpen = searchInput.classList.contains("openInput")
      searchInput.classList.toggle("openInput", !isOpen)
      backdrop.classList.toggle("show", !isOpen)
      btn.classList.toggle("activeSearchBtn", !isOpen)

      if (!isOpen) {
        document.body.classList.add("lock")
        document.addEventListener("click", handleOutsideClick)
      } else {
        document.body.classList.remove("lock")
        document.removeEventListener("click", handleOutsideClick)
      }
    }

    const closeSearch = () => {
      if (!searchInput.classList.contains("openInput")) return

      searchInput.classList.remove("openInput")
      backdrop.classList.remove("show")
      searchBtns.forEach((btn) => btn.classList.remove("activeSearchBtn"))
      document.body.classList.remove("lock")
      document.removeEventListener("click", handleOutsideClick)
    }

    const handleOutsideClick = (e) => {
      const isClickInside =
        searchInput.contains(e.target) || [...searchBtns].some((btn) => btn.contains(e.target))
      if (!isClickInside) {
        closeSearch()
      }
    }

    searchBtns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.stopPropagation()
        toggleSearch(btn)
      })
    })
  }
}
